import { BaseApi } from './base.api'

export class DictWordExampleApi extends BaseApi {
	constructor() {
		super('api/editor/dict-word-example')
	}

	async create(data) {
		const rs = await this.post('', data)
		return rs
	}

	async update(data) {
		const rs = await this.put(`/${data.id}`, data)
		return rs
	}

	async remove(data) {
		const rs = await this.delete(`/${data.id}`)
		return rs
	}
}
